module.exports = __webpack_public_path__ + "static/media/10_Conexion_Conica.ba1574c1.png";